/**
 * assets/mega-menu.js
 * ─────────────────────────────────────────────────────────────────────────
 * Handles:
 *   Desktop — CSS :hover controls the panels (no JS needed for open/close).
 *             JS only adds keyboard accessibility + click-outside close.
 *   Mobile  — Drawer open/close, scroll-lock, accordion toggles,
 *             swipe-to-close, focus management.
 * ─────────────────────────────────────────────────────────────────────────
 */

(function () {
  'use strict';

  /* ── Helpers ─────────────────────────────────────────────────────── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  /* ── Scroll lock ─────────────────────────────────────────────────── */
  function lockScroll() {
    var y = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + y + 'px';
    document.body.style.width = '100%';
    document.body.dataset.scrollY = y;
  }

  function unlockScroll() {
    var y = parseInt(document.body.dataset.scrollY || '0', 10);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, y);
  }


  /* ══════════════════════════════════════════════════════════════════
     DESKTOP — keyboard accessibility for CSS-hover panels
     ════════════════════════════════════════════════════════════════ */

  function initDesktop() {
    /* Escape key closes any open dropdown while focus is inside it */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var panel = qs('.looks-mega, .shop-mega, .simple-dropdown');
      if (panel && getComputedStyle(panel).display !== 'none') {
        var trigger = panel.closest('.mm-nav-item');
        if (trigger) {
          var link = qs('.mm-nav-link', trigger);
          if (link) link.focus();
        }
      }
    });

    /* Click outside closes panels (belt-and-suspenders, CSS :hover is primary) */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.mm-nav-item')) {
        /* Nothing needed — CSS :hover handles this natively */
      }
    });
  }


  /* ══════════════════════════════════════════════════════════════════
     MOBILE DRAWER
     ════════════════════════════════════════════════════════════════ */

  var drawer, overlay, openBtns;
  var touchStartX = null;

  /* Exposed globals — called by onclick attributes in Liquid */
  window.mobOpen = function () {
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('open');
    lockScroll();
    /* Focus first focusable element */
    var first = qs('a[href], button:not([disabled])', drawer);
    if (first) setTimeout(function () { first.focus(); }, 60);
    qsa('.mm-hamburger').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });
  };

  window.mobClose = function () {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('open');
    unlockScroll();
    qsa('.mm-hamburger').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
    /* Return focus to hamburger */
    var ham = qs('.mm-hamburger');
    if (ham) ham.focus();
  };

  window.mobAccordion = function (btn) {
    var body = btn.nextElementSibling;
    if (!body) return;
    var isOpen = btn.classList.contains('open');

    /* Close all other accordions first */
    qsa('.mob-accordion-btn.open').forEach(function (other) {
      if (other !== btn) {
        other.classList.remove('open');
        other.setAttribute('aria-expanded', 'false');
        var otherBody = other.nextElementSibling;
        if (otherBody) {
          otherBody.classList.remove('open');
          otherBody.setAttribute('aria-hidden', 'true');
        }
      }
    });

    btn.classList.toggle('open', !isOpen);
    btn.setAttribute('aria-expanded', !isOpen);
    body.classList.toggle('open', !isOpen);
    body.setAttribute('aria-hidden', isOpen);
  };

  function initMobile() {
    drawer  = qs('#mob-drawer');
    overlay = qs('#mob-overlay');
    if (!drawer) return;

    /* Escape key closes drawer */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) {
        window.mobClose();
      }
    });

    /* Swipe left to close */
    drawer.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    drawer.addEventListener('touchmove', function (e) {
      if (touchStartX === null) return;
      var dx = touchStartX - e.touches[0].clientX; /* positive = swiping left */
      if (dx > 0) {
        drawer.style.transform = 'translateX(-' + Math.min(dx, 320) + 'px)';
      }
    }, { passive: true });

    drawer.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var dx = touchStartX - e.changedTouches[0].clientX;
      drawer.style.transform = '';
      if (dx > 60) {
        window.mobClose();
      }
      touchStartX = null;
    }, { passive: true });

    /* Focus trap inside open drawer */
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusable = qsa(
        'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"])',
        drawer
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    });
  }


  /* ══════════════════════════════════════════════════════════════════
     INIT
     ════════════════════════════════════════════════════════════════ */

  function init() {
    initDesktop();
    initMobile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());
